/**
 * loadSession.js
 * Written by: Alex Kasemir
 */

import { getNotifications } from 'store/notification/actions/getNotifications';
import { trackUser } from 'utils/event';
import alertActions from 'store/alert/actions';

import { getUser } from '../getUser';
import { selectUser } from '../selectUser';
import { removeToken } from '../removeToken';
import { validateReferral } from '../validateReferral';
import { saveFriends } from '../saveFriends';
import resultActions from '../../../result/actions';
import { clearQuestionsMeta } from '../../../question/actions/clearQuestionsMeta';
import { getQuiz } from '../../../quiz/actions/getQuiz';
import { selectNextQuestion } from '../../../question/actions/selectNextQuestion';
import { getQuizResults } from '../../../quiz/actions/getQuizResults';

export const LOAD_SESSION_START = `LOAD_SESSION_START`;
export const LOAD_SESSION_SUCCESS = `LOAD_SESSION_SUCCESS`;
export const LOAD_SESSION_FAILURE = `LOAD_SESSION_FAILURE`;

export const loadSessionStart = () => ({
  type: LOAD_SESSION_START,
});

export const loadSessionSuccess = () => ({
  type: LOAD_SESSION_SUCCESS,
});

export const loadSessionFailure = (error) => ({
  type: LOAD_SESSION_FAILURE,
  error,
});

/**
 * Description of the loadSession action
 */
export const loadSession = () => {
  return async (dispatch, getState) => {
    dispatch(loadSessionStart());
    try {
      const user = await dispatch(getUser());
      if (__CLIENT__ && !user.email_confirmed && user.confirmation_email_queued) {
        dispatch(alertActions.createAlert({
          type: `warning`,
          message: `You haven't confirmed your email yet. Please check ${user.email}`,
          time: 5000,
        }));
      }
      if (getState().extra.referral) {
        dispatch(validateReferral());
      }
      if (__CLIENT__) {
        dispatch(saveFriends());
        trackUser(user.id.toString());
      }
      dispatch(selectUser(user.id));
      if (getState().quiz.selected) {
        const quizId = getState().quiz.selected;
        dispatch(clearQuestionsMeta());
        dispatch(resultActions.clearResults(getState().result.selected));
        const response = await dispatch(getQuizResults(quizId, false));
        const hasAttempted = Boolean(response.data.attempted && response.data.attempted > 0);
        if (getState().question.selected) {
          await dispatch(getQuiz(quizId, hasAttempted));
          dispatch(selectNextQuestion(getState().question.selected));
        }
      }
      dispatch(getNotifications());
      dispatch(loadSessionSuccess());
    } catch (e) {
      dispatch(removeToken());
      dispatch(loadSessionFailure(e));
    }
  };
};
